<page-heading [title]="'channel.apis.pageTitle' | translate" [description]="'channel.apis.pageDescription' | translate" />

@if (loadingContent) {
<content-loading-list></content-loading-list>
}

@if (!loadingContent && !channel?.apis) {
  <empty-records-component [message]="'channel.apis.emptyMessage' | translate"
  [subMessage]="'channel.apis.emptySubMessage' | translate"
  [buttonClass]="'btn btn-info fw-bold'"
  [labelButton]="'channel.apis.generateNewCredentials' | translate"
  (emitEvent)="generateNewCredentials()">
</empty-records-component>
}

@if (!loadingContent && channel?.apis) {
<div class="row mb-3">
  <div class="col-6">
    <div class="card">
      <div class="card-body">
        <h4 class="header-title mb-3">{{ 'channel.apis.credentialsTitle' | translate }}</h4>
        <hr class="bg-dark-lighten my-3">
        <div class="mt-3">
          <p class="mt-4 mb-1"><strong><i class="uil uil-at"></i> UUID:</strong></p>
          <p>
            {{channel.apis.uuid}}
            <a href="javascript:void(0);" (click)="copyContentUUID()" class="action-icon" [matTooltip]="'channel.apis.copyUuid' | translate"> <i class="mdi mdi-content-copy"></i></a>
          </p>

          <p class="mt-3 mb-1"><strong><i class="uil uil-phone"></i> Token:</strong></p>
          <p>
            {{channel.apis.token}}
            <a href="javascript:void(0);" (click)="copyContentToken()" class="action-icon"  [matTooltip]="'channel.apis.copyToken' | translate"> <i class="mdi mdi-content-copy"></i></a>
          </p>

          <p class="mt-3 mb-1"><strong><i class="uil uil-location-point"></i> {{ 'channel.apis.date' | translate }}</strong></p>
          <p>{{channel.apis.createdAt | timezoneDate: 'DD/MM/YYYY HH:MM:SS': getTimezoneCompanyCurrentUser()}}</p>

          <hr class="bg-dark-lighten my-3">
          <button [disabled]="loading" class="btn btn-primary" (click)="generateNewCredentials()">
            {{ loading ? '' : ('channel.apis.generateNewCredentials' | translate) }}
            @if(loading) {
            <mat-spinner [diameter]="25" [color]="'accent'" mode="indeterminate" />
            }
          </button>
        </div>


      </div>
    </div>
  </div>
  <div class="col-6">

    <div class="card">
      <div class="card-body">
        <h4 class="header-title mb-3">{{ 'channel.apis.beforeAccessTitle' | translate }}</h4>
        <hr class="bg-dark-lighten my-3">
        <!-- <p>
          <i class="ri-file-list-2-line font-20 text-primary"></i>
          Gerar\ o token de acesso à API
        </p> -->
        <p>
          <i class="ri-checkbox-circle-line font-20 text-primary"></i>
          {{ 'channel.apis.stepCopyCredentials' | translate }}
        </p>
        <p>
          <i class="ri-shield-line font-20 text-primary"></i>
          {{ 'channel.apis.stepAccessDocs' | translate }} <a href="https://developer.trendmulti.com.br" target="_blank">developer.trendmulti.com.br</a>
        </p>
        <p>
          <i class="ri-task-line font-20 text-primary"></i>
          {{ 'channel.apis.stepAccessSwagger' | translate }}
          @if (env === 'prod') {
          <a href="https://apis.trendmulti.com.br" target="_blank">apis.trendmulti.com.br</a>
          } @else {
            <a href="https://staging-apis.trendmulti.com.br" target="_blank">staging-apis.trendmulti.com.br</a>
          }
        </p>
        <p>
          <i class="ri-checkbox-circle-line font-20 text-primary"></i>
          {{ 'channel.apis.stepSupport' | translate }}
        </p>

      </div>
    </div>
  </div>

</div>
}